import { CircuitBoard, MapPinOff, Timer, Truck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { EmptyState } from '../../components/empty-state'

/**
 * The teaching empty states for vehicle data (spec §9).
 *
 * These are the states an installer meets on commissioning day, so each one
 * names the thing to check rather than reporting that data is absent. They live
 * together because the vehicle detail view (phase 1) and the fleet list use the
 * same wording, and a copy that drifts between two screens undermines both.
 */

export function NoVehiclesState() {
  const { t } = useTranslation()
  return (
    <EmptyState
      icon={Truck}
      title={t('vehicles:empty.noVehicles.title')}
      description={t('vehicles:empty.noVehicles.description')}
    />
  )
}

/** Shown wherever a CAN-derived value (fuel, odometer, RPM) is missing. */
export function NoCanDataState({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation()
  return (
    <EmptyState
      icon={CircuitBoard}
      compact={compact}
      title={t('vehicles:empty.noCanData.title')}
      description={t('vehicles:empty.noCanData.description')}
    />
  )
}

/** Engins BTP whose hour meter is not on the bus — maintenance falls back to ignition. */
export function NoHourMeterState({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation()
  return (
    <EmptyState
      icon={Timer}
      compact={compact}
      title={t('vehicles:empty.noHourMeter.title')}
      description={t('vehicles:empty.noHourMeter.description')}
    />
  )
}

export function NoPositionState({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation()
  return (
    <EmptyState
      icon={MapPinOff}
      compact={compact}
      title={t('vehicles:empty.noPosition.title')}
      description={t('vehicles:empty.noPosition.description')}
    />
  )
}
